import { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const BlogHeroSection = () => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
        }
      },
      { threshold: 0.3 }
    )

    if (contentRef.current) {
      observer.observe(contentRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <CommonHeroSection>
      <section className="relative min-h-[65vh] 2xl:min-h-[60vh] overflow-hidden">
        
        {/* Header */}
        <div className="relative z-20">
          <Header />
        </div>

        {/* Content */}
        <div
          ref={contentRef}
          className={`
            relative z-10 mx-auto flex min-h-[65vh] 2xl:min-h-[60vh] 
            w-[70%] max-w-[1000px] flex-col items-center justify-center px-4 text-center

            transition-all duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)]

            ${visible 
              ? 'opacity-100 scale-100 translate-y-0' 
              : 'opacity-0 scale-75 translate-y-10'}
          `}
        >
          
          {/* Heading */}
          <h1
            className={`
              mb-4 font-rajdhani text-4xl font-bold 
              md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl

              transition-all duration-1000 delay-100
              ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
            `}
          >
            Insights for Technology Leaders
          </h1>

          {/* Paragraph */}
          <p
            className={`
              max-w-[62ch] font-gilroy-medium text-base leading-relaxed text-gray-400 
              md:text-xl lg:text-3xl xl:text-3xl 2xl:text-4xl

              transition-all duration-1000 delay-300
              ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
            `}
          >
            Practical guidance, technical deep-dives, and strategic perspectives from our engineering team.
          </p>

        </div>

      </section>
    </CommonHeroSection>
  )
}

export default BlogHeroSection